import { handleActions } from "redux-actions";
import {
  SHOW_FILTER_OVERLAY,
  HIDE_FILTER_OVERLAY,
  UPDATE_VIEWPORT_CATEGORY,
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT,
  SHOW_SORT_OVERLAY,
  HIDE_SORT_OVERLAY,
  SHOW_SUCCESS_MESSAGE,
  HIDE_SUCCESS_MESSAGE,
  TOGGLE_SECONDARY_LIST
} from "./constants";

const initialState = {
  isFilterOverlayVisible: false,
  isSortOverlayVisible: false,
  isFilterButtonFocused: false,
  isSecondaryListVisible: false,
  successMessage: {
    isVisible: false,
    message: "",
    linkText: "",
    linkUrl: ""
  },
  viewportCategory: SMALL_VIEWPORT
};

const iNoBounce = CLIENT
  ? require("inobounce")
  : { enable: () => {}, disable: () => {}, isScrollSupported: false };

const validateViewport = (state, viewport) =>
  [SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT].includes(viewport)
    ? viewport
    : state.viewportCategory;

export default handleActions(
  {
    [SHOW_FILTER_OVERLAY]: state => {
      document.body.style.overflow = "hidden";
      if (iNoBounce.isScrollSupported) {
        iNoBounce.enable();
      }

      return { ...state, isFilterOverlayVisible: true };
    },

    [HIDE_FILTER_OVERLAY]: state => {
      document.body.style.overflow = "initial";
      state.isFilterButtonFocused = true;
      if (iNoBounce.isScrollSupported) {
        iNoBounce.disable();
      }

      return { ...state, isFilterOverlayVisible: false };
    },
    [SHOW_SORT_OVERLAY]: state => {
      document.body.style.overflow = "hidden";
      state.isFilterButtonFocused = false;
      if (iNoBounce.isScrollSupported) {
        iNoBounce.enable();
      }

      return { ...state, isSortOverlayVisible: true };
    },
    [HIDE_SORT_OVERLAY]: state => {
      document.body.style.overflow = "initial";
      if (iNoBounce.isScrollSupported) {
        iNoBounce.disable();
      }

      return { ...state, isSortOverlayVisible: false };
    },
    [TOGGLE_SECONDARY_LIST]: state => ({
      ...state,
      isSecondaryListVisible: !state.isSecondaryListVisible
    }),

    [UPDATE_VIEWPORT_CATEGORY]: (state, action) => ({
      ...state,
      viewportCategory: validateViewport(state, action.payload.viewportCategory)
    }),

    [SHOW_SUCCESS_MESSAGE]: (state, action) => ({
      ...state,
      successMessage: {
        isVisible: true,
        message: action.payload.message,
        linkText: action.payload.linkText,
        linkUrl: action.payload.linkUrl
      }
    }),

    [HIDE_SUCCESS_MESSAGE]: state => ({
      ...state,
      successMessage: initialState.successMessage
    })
  },
  initialState
);
